import React from 'react';
import { CloseButton, ComplexValue, Numberbox, SelectSingleShortList, Textarea } from 'ui';
import styles from './control-panel.scss';
import { getAxisDescription, getAxisProperty } from 'app/area/risk-matrix-administration/mappers/map-to-risk-matrix-definition';
import { RiskMatrixAxes, RiskMatrixCell } from 'app/area/risk-matrix-administration/types-store';
import { CodeListItem } from 'app/area/codetable/list/types-store';
import { RiskMatrixTranslation } from 'app/area/risk-matrix-administration/constants';

interface ControlPanelProps {
  translation: RiskMatrixTranslation;
  axes: RiskMatrixAxes;
  cell: RiskMatrixCell;
  updateSelectedCellRiskWeight: (riskWeight: number) => void;
  updateSelectedCellRiskArea: (riskArea: ComplexValue<number>) => void;
  riskAreas: CodeListItem[];
  readOnly: boolean;
  onClose: () => void;
}

export const ControlPanel = ({ translation, axes, cell, updateSelectedCellRiskArea, updateSelectedCellRiskWeight,
  riskAreas, readOnly, onClose }: ControlPanelProps) => cell && !readOnly ?
    <div id="control_panel" className={styles.container}>
      <div className={styles.controlPanel}>
        <div className={`${styles.itemContainer} ${styles.closeButton}`}>
          <CloseButton
            autofocus={false}
            onClick={onClose}
          />
        </div>
        <div className={styles.itemContainer}>
          <Textarea
            className={styles.item}
            componentId="risk_matrix_x_axis_value"
            readOnly={true}
            label={{ text: getAxisDescription(axes[0].codetableId, translation), visible: true }}
            value={axes[0].items.find(axisItem => axisItem.id === cell[getAxisProperty(axes[0].codetableId)]).description}
            onChange={undefined}
          />
        </div>
        {axes[1] ?
          <div className={styles.itemContainer}>
            <Textarea
              className={styles.item}
              componentId="risk_matrix_y_axis_value"
              readOnly={true}
              label={{ text: getAxisDescription(axes[1].codetableId, translation), visible: true }}
              value={axes[1].items.find(axisItem => axisItem.id === cell[getAxisProperty(axes[1].codetableId)]).description}
              onChange={undefined}
            />
          </div> : null
        }
        <div className={styles.itemContainer}>
          <Numberbox
            className={styles.item}
            componentId="risk_matrix_cell_weight"
            readOnly={false}
            label={{ text: translation.weight, visible: true }}
            value={cell.riskWeight}
            onChange={updateSelectedCellRiskWeight}
            useThousand=" "
            maxValue={999999999}
            minValue={0}
            textInvalidRangeError={translation.must_be_within_range}
          />
        </div>
        <div className={`${styles.itemContainer} ${styles.riskAreasContainer}`}>
          <SelectSingleShortList
            options={riskAreas.map(riskArea => ({
              value: riskArea.id,
              backgroundColor: riskArea.colour,
              foregroundColor: riskArea.colour,
              description: riskArea.description
            }))}
            valueItem={{
              value: riskAreas.find(riskArea => cell.riskArea === riskArea.id)?.id,
              description: riskAreas.find(riskArea => cell.riskArea === riskArea.id)?.description
            }}
            className={undefined}
            componentId="risk_area_picker"
            onChange={updateSelectedCellRiskArea}
            label={{ text: translation.risk_area }}
            isVertical={true}
          />
        </div>
      </div>
    </div> : null;
